import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const [invalidToken, setInvalidToken] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchCollectionList = async () => {
        const baseURL = process.env.REACT_APP_API_URL;
        const apiPath = "/visualizer/getcollectionlist";
        const url = `${baseURL}${apiPath}`;

        const requestBody = { status: "Active,De-active" };

        try {
            const response = await axios.post(url, requestBody, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            

        } catch (err) {
            console.error("API Error:", err.message);
            if (err?.response?.status === 401 || err?.message?.includes("401")) {
                localStorage.removeItem("token");
                setInvalidToken(true);
            }
        } finally {
            setLoading(false);
        }
    };

   
    useEffect(() => {
        if (token) {
            fetchCollectionList();
        } else {
            setLoading(false);
        }
    }, []);

    
    if (!token) {
        return <Navigate to="/" replace />;
    }

   
    if (invalidToken) {
        return <Navigate to="/" replace />;
    }

    
    if (loading) return null;

    return children;
};

export default ProtectedRoute;
